import { useEffect, useState } from "react";
import { DownloadSimple, X } from "@phosphor-icons/react";

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("avb_install_dismissed") === "1") return;
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const dismiss = () => { setShow(false); localStorage.setItem("avb_install_dismissed", "1"); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setShow(false);
    setDeferred(null);
  };

  if (!show) return null;
  return (
    <div data-testid="pwa-install-prompt" className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-sm rounded-2xl border border-stone-200 bg-white p-4 shadow-xl md:left-6 md:right-auto">
      <div className="flex items-start gap-3">
        <div className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-primary text-white"><DownloadSimple size={22} /></div>
        <div className="min-w-0 flex-1">
          <p className="font-heading text-sm font-semibold text-stone-900">Install Avinya</p>
          <p className="mt-0.5 text-xs text-stone-500">Add Avinya Bookings to your home screen for a faster, app-like experience.</p>
          <div className="mt-3 flex gap-2">
            <button data-testid="pwa-install-btn" onClick={install} className="rounded-full bg-primary px-4 py-1.5 text-xs font-semibold text-white">Install</button>
            <button data-testid="pwa-install-dismiss" onClick={dismiss} className="rounded-full border border-stone-200 px-4 py-1.5 text-xs font-medium text-stone-600">Not now</button>
          </div>
        </div>
        <button aria-label="Dismiss" onClick={dismiss} className="text-stone-400 hover:text-stone-600"><X size={18} /></button>
      </div>
    </div>
  );
};
